// routes/_app.profile.edit.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.profile.edit')

export const handle = { name: 'profile/edit' }

export default dynamic(getClientModule, { ssr: false })
